<template>
  <template v-if="!loading && detail">
    <inscriptions-details-main-cursus v-bind:detail="detail" />
    <refonte-collapse
      v-if="detail.titre"
      class="mt-[12px]"
      v-bind:title_icon="IconMyAccount"
      title="Participant"
      v-bind:start_open="true">
      <template v-if="detail.participant">
        <refonte-table
          key="participant-1"
          table_index="participant-1"
          v-bind:columns="columnsParticipant"
          v-bind:data="[detail.participant]">
        </refonte-table>
      </template>
      <refonte-search-results-empty v-else />
    </refonte-collapse>
    <refonte-collapse
      v-if="detail.titre"
      class="mt-[12px]"
      v-bind:title_icon="IconTestValidation"
      title="Documents"
      v-bind:start_open="true">
      <div class="flex flex-wrap gap-[8px]">
        <refonte-item-file-convention-line
          v-if="detail.convention?.id"
          v-bind:open_signature_manuelle="openSignatureManuelle"
          v-bind:signature_manuelle="signatureManuelle"
          id="convention"
          title="Convention de formation"
          v-bind:convention="detail.convention"
          v-bind:on_submit="fetchInscription"
          v-bind:participant_nom_prenom="detail.participant.nomPrenom"
          v-bind:session_date="dates_helpers.methods.formatDates(detail)"
          v-bind:formation_title="detail.titre"
          v-bind:client_id="detail.clientId" />
        <refonte-item-file-convention-line
          v-if="detail.conventionIndividuelle?.id"
          id="convention-indiv"
          title="Convention individuelle"
          v-bind:open_signature_manuelle="openSignatureManuelleIndiv"
          v-bind:signature_manuelle="signatureManuelleIndiv"
          v-bind:convention="detail.conventionIndividuelle"
          v-bind:on_submit="fetchInscription"
          v-bind:participant_nom_prenom="detail.participant.nomPrenom"
          v-bind:session_date="dates_helpers.methods.formatDates(detail)"
          v-bind:formation_title="detail.titre"
          v-bind:client_id="detail.clientId" />
        <refonte-item-file-pif-line
          v-if="detail.pif?.id"
          id="pif"
          title="Protocole Individuel de Formation"
          v-bind:open_signature_manuelle="openSignatureManuellePif"
          v-bind:signature_manuelle="signatureManuellePif"
          v-bind:pif="detail.pif"
          v-bind:on_submit="fetchInscription"
          v-bind:participant_nom_prenom="detail.participant.nomPrenom"
          v-bind:session_date="dates_helpers.methods.formatDates(detail)"
          v-bind:formation_title="detail.titre"
          v-bind:client_id="detail.clientId" />
        <refonte-item-file
          v-if="!detail?.isGenerationSousProduit"
          id="certificat"
          title="Certificat de réalisation"
          subtitle="Cursus"
          v-bind:no_download_text="detail.termine ? '-' : 'À venir'"
          v-bind:on_click_download="
            detail.certificatId
              ? () => downloadCertificat(detail?.clientId, detail?.certificatId)
              : undefined
          "
          v-bind:no_signature_needed="true" />
        <refonte-item-file
          v-if="moduleCertificatIds.length"
          id="certificat-modules"
          title="Certificat de réalisation (.zip)"
          subtitle="Par module"
          v-bind:no_download_text="detail.termine ? '-' : 'À venir'"
          v-bind:on_click_download="
            () => downloadCertificatZipByIds(moduleCertificatIds)
          "
          v-bind:no_signature_needed="true" />
        <refonte-item-file
          id="bon-commande"
          title="Bon de commande"
          label_center
          v-bind:on_click_download="
            () =>
              downloadBonCommande(
                detail?.clientId,
                detail?.commandeId,
                detail?.commandeReference
              )
          "
          v-bind:no_signature_needed="true" />
      </div>
    </refonte-collapse>
    <refonte-collapse
      v-if="detail.titre && detail.factures && detail.factures.length > 0"
      class="mt-[12px]"
      v-bind:title_icon="IconFactures"
      title="Factures"
      v-bind:start_open="true">
      <template v-if="detail.factures && detail.factures.length > 0">
        <refonte-table
          key="factures-1"
          table_index="factures-1"
          v-bind:columns="columnsFactures"
          v-bind:data="detail.factures">
        </refonte-table>
      </template>
      <refonte-search-results-empty v-else />
    </refonte-collapse>
    <refonte-collapse
      v-if="detail.titre && detail.prestations && detail.prestations.length > 0"
      class="mt-[12px]"
      v-bind:title_icon="IconList"
      title="Prestations"
      v-bind:start_open="true">
      <template v-if="detail.prestations">
        <refonte-table
          key="prestations-1"
          table_index="prestations-1"
          v-bind:columns="columnsPrestationsPrices"
          v-bind:data="detail.prestations">
        </refonte-table>
      </template>
      <refonte-search-results-empty v-else />
    </refonte-collapse>
    <refonte-collapse
      v-if="detail.titre && detail.formations"
      class="mt-[12px]"
      v-bind:title_icon="IconFormations"
      title="Modules"
      v-bind:start_open="true">
      <template v-if="detail.formations.length">
        <refonte-table
          v-bind:on_details="goToDetailsFormation"
          key="formations-cursus-1"
          table_index="formations-cursus-1"
          v-bind:columns="columnsFormations"
          v-bind:data="detail.formations.map((f) => formatFormation(f))">
        </refonte-table>
      </template>
      <refonte-search-results-empty v-else />
    </refonte-collapse>
    <refonte-collapse
      v-if="
        detail.titre &&
        detail.otherParticipants &&
        detail.otherParticipants.length > 0
      "
      class="mt-[12px]"
      v-bind:title_icon="IconConventionCollective"
      v-bind:title="`Autres participants (${detail.otherParticipants.length})`">
      <template v-if="detail.otherParticipants">
        <refonte-table
          v-bind:on_details="goToDetailsParticipant"
          key="otherParticipants-1"
          table_index="otherParticipants-1"
          v-bind:columns="columnsParticipants"
          v-bind:data="detail.otherParticipants"
          class="table-no-space-between">
        </refonte-table>
      </template>
      <refonte-search-results-empty v-else />
    </refonte-collapse>
  </template>
  <spinner
    v-else
    sizes="w-20 h-20"
    thickness="border-8" />
</template>

<script setup lang="ts">
  import Spinner from '@/components/utils/spinner.vue';
  import { computed, h, onMounted, ref, watch } from 'vue';
  import InscriptionsDetailsMainCursus from '@/views/_espace/_refonte/gestion/_inscriptions-details/inscriptions-details-main-cursus.vue';
  import RefonteCollapse from '@/components/refonte/collapse/refonte-collapse.vue';
  import IconTestValidation from '@/assets/img/refonte/icons/information/icon-test-validation.svg?component';
  import IconList from '@/assets/img/refonte/icons/information/icon-list.svg?component';
  import IconMyAccount from '@/assets/img/refonte/icons/users/icon-my-account.svg?component';
  import IconConventionCollective from '@/assets/img/refonte/icons/users/icon-convention-collective.svg?component';
  import IconFactures from '@/assets/img/refonte/icons/menu/icon-bills.svg?component';
  import IconDownload from '@/assets/img/refonte/icons/display/icon-download.svg?component';
  import { useRoute, useRouter } from 'vue-router';
  import {
    downloadBonCommande,
    downloadCertificat,
    downloadCertificatZipByIds,
    downloadFacture
  } from '@/mixin/client_download__functions';
  import {
    Detail,
    Participant,
    PrestationPrice
  } from '@/types/gestion/inscriptions-details-types';
  import RefonteSearchResultsEmpty from '@/components/refonte/inputs/refonte-search-results-empty.vue';
  import RefonteTable from '@/components/refonte/tables/refonte-table.vue';
  import RefonteItemFile from '@/components/refonte/items/refonte-item-file.vue';
  import IconFormations from '@/assets/img/refonte/icons/menu/icon-training.svg?component';
  import {
    Inscription,
    InscriptionFormation,
    InscriptionType
  } from '@/types/gestion/inscriptions-types';
  import { API } from '@/http-common';
  import number_utils from '@/mixin/number_utils';
  import { Facture } from '@/types/gestion/factures-types';
  import {
    buildProduitTypeLabel,
    buildProduitTypeShortcut
  } from '@/stores/utils';
  import RefonteTableItemParticipantNameAccountStatus from '@/components/refonte/tables/refonte-table-item-participant-name-account-status.vue';
  import dates_helpers from '@/mixin/dates_helpers';
  import RefonteItemFileConventionLine from '@/components/refonte/items/refonte-item-file-convention-line.vue';
  import RefonteItemFilePifLine from '@/components/refonte/items/refonte-item-file-pif-line.vue';

  const detail = ref<Detail>();
  const route = useRoute();
  const id = computed(() => route.query.id);
  const loading = ref<boolean>(false);
  watch(
    () => route.query.id,
    () => fetchInscription()
  );

  const fetchInscription = async () => {
    loading.value = true;
    const response = await API.get(
      `client/v2/inscriptions/cursus/${id.value}/details`
    );

    if (response && response.data) {
      detail.value = mapInscriptionDetail(response.data);
      shouldAddCertificatColumn(response.data)
        ? columnsFormations.push(certificatColumn)
        : columnsFormations;
    }
    loading.value = false;
  };

  const shouldAddCertificatColumn = (detail) => {
    return !detail?.isGenerationGlobale;
  };

  const mapInscriptionDetail = (detail) => {
    return {
      ...detail,
      formations: detail?.formations?.map((f) => mapFormation(f))
    };
  };
  const buildCertificaLabel = (certificatId) =>
    certificatId ? 'Télécharger' : 'À venir';

  const convertDateFormat = (dateStr) => {
    const [day, month, year] = dateStr.split('/');
    return `${year}-${month}-${day}`;
  };

  const isDateInThePast = (formation) => {
    if (!formation.dateFin) {
      return false;
    }
    const validDate = convertDateFormat(formation.dateFin);
    const parsedDate = new Date(validDate);
    return parsedDate <= new Date();
  };

  const mapFormation = (formation) => {
    return {
      ...formation,
      certificatLabel: isDateInThePast(formation)
        ? buildCertificaLabel(formation.certificatId)
        : undefined
    };
  };

  onMounted(async () => {
    await fetchInscription();
  });

  const router = useRouter();
  const goToDetailsParticipant = (row: Participant) => {
    router.push(`/gestion/inscriptions-cursus?id=${row.id}`);
  };
  const getInscriptionTypeShortcut = (inscriptionType: InscriptionType) => {
    if (inscriptionType == InscriptionType.SESSION) {
      return 'session';
    } else if (inscriptionType == InscriptionType.ELEARNING) {
      return 'elearning';
    } else if (inscriptionType == InscriptionType.CURSUS) {
      return 'cursus';
    }
    return undefined;
  };

  const goToDetailsFormation = (row: InscriptionFormation) => {
    const inscriptionTypeShortcut = getInscriptionTypeShortcut(
      row.inscriptionType
    );
    router.push(
      `/gestion/inscriptions-${inscriptionTypeShortcut}?id=${row.inscriptionId}`
    );
  };

  const moduleCertificatIds = computed(() => {
    return detail.value?.formations?.length
      ? detail.value?.formations?.reduce(
          (acc: string[], cur: Inscription) =>
            cur?.certificatId ? [...acc, cur?.certificatId] : acc,
          []
        )
      : [];
  });

  const formatFormation = (f) => {
    let dates = '-';
    if (f.dateDebut && f.dateFin) {
      if (f.dateDebut == f.dateFin) {
        dates = `${f.dateDebut}`;
      } else {
        dates = `${f.dateDebut} - ${f.dateFin}`;
      }
    }
    return {
      ...f,
      datesFormations: dates,
      disabled: f.sessionStatut?.id === 5,
      typeShortcut: addSessionTypeShortcut(
        buildProduitTypeShortcut(f.type.id, f.lienElearning),
        f.sessionStatut?.id
      ),
      typeLabel: addSessionTypeLabel(
        buildProduitTypeLabel(f.type.label, f.lienElearning),
        f.sessionStatut?.id
      )
    };
  };

  const addSessionTypeLabel = (flags: string[], sessionStatutId: number) => {
    return sessionStatutId === 5 ? [...flags, 'Annulée'] : flags;
  };

  const addSessionTypeShortcut = (flags: string[], sessionStatutId: number) => {
    return sessionStatutId === 5 ? [...flags, 'annulee'] : flags;
  };

  const columnsFormations = [
    {
      content_index: 'titre',
      tags_type: 'typeShortcut',
      tags_type_label: 'typeLabel',
      content_sub_text: (row: Inscription) =>
        `${row.modeLabel === 'Intra' ? `${row.modeLabel} - ` : ''}${row.lieu ?? ''}`,
      width: 308
    },
    {
      content_index: 'datesFormations',
      label: 'Dates de formation',
      width: 190
    },
    {
      content_index: 'statutLabel',
      label: 'Statut',
      width: 85,
      content_custom: (row: Inscription) =>
        h('span', {
          innerHTML: row.statutLabel,
          class:
            row.statutLabel === 'Annulé' || row.statutLabel === 'Transféré'
              ? 'text-jinius-red'
              : ''
        })
    },
    {
      content_index: 'lieu',
      label: 'Site',
      width: 85
    }
  ];

  const certificatColumn = {
    content_index: 'certificatLabel',
    label: 'Certificat',
    min_width: 117,
    width: 130,
    on_click: (row: Inscription) => {
      return row.certificatId && isDateInThePast(row)
        ? downloadCertificat(detail.value?.clientId, row.certificatId)
        : undefined;
    },
    content_icon: (row: Inscription) =>
      isDateInThePast(row) && row.certificatId ? IconDownload : undefined,
    class: () => '!flex-grow-0'
  };

  const getParticipantInscriptionStatus = (status: string) => {
    switch (status) {
      case 'En attente':
        return 'En attente';
      case 'Confirmé':
        return 'Confirmée';
      case 'Annulé':
        return 'Annulée';
      case 'Transférée':
        return 'Annulée';
      default:
        return '-';
    }
  };
  const columnsPrestationsPrices = [
    {
      content_index: 'libelle',
      label: 'Libellé',
      width: 308
    },
    {
      content_index: 'montantHT',
      label: 'Montant HT',
      width: 120,
      content_custom: (row: PrestationPrice) =>
        h('span', {
          innerHTML: number_utils.methods.formatCurrency(row.montantHT)
        })
    },
    {
      content_index: 'montantTVA',
      label: 'Montant TVA',
      width: 120,
      content_custom: (row: PrestationPrice) =>
        h('span', {
          innerHTML: number_utils.methods.formatCurrency(row.montantTVA)
        })
    },
    {
      content_index: 'montantTTC',
      label: 'Montant TTC',
      width: 120,
      content_custom: (row: PrestationPrice) =>
        h('span', {
          innerHTML: number_utils.methods.formatCurrency(row.montantTTC)
        })
    },
    {
      content_index: 'montantRegle',
      label: 'Montant réglé',
      width: 120,
      content_custom: (row: PrestationPrice) =>
        h('span', {
          innerHTML: number_utils.methods.formatCurrency(row.montantRegle)
        })
    }
  ];
  const columnsParticipant = [
    {
      content_index: 'nomPrenom',
      label: 'Nom',
      width: 308,
      content_custom: (row: Participant) =>
        h(RefonteTableItemParticipantNameAccountStatus, { row })
    },
    {
      content_index: 'inscription',
      label: 'Inscription',
      width: 120,
      content_custom: (row: Participant) =>
        h('span', {
          innerHTML: getParticipantInscriptionStatus(row.inscription.label)
        })
    },
    {
      content_index: 'positionnement',
      label: 'T. Positionnement',
      width: 140,
      content_custom: (row: Participant) =>
        h('span', {
          innerHTML: row.positionnement
            ? row.positionnement.label
            : 'Non requis'
        })
    },
    {
      content_index: 'validation',
      label: 'T. valid. acquis',
      width: 120,
      content_custom: (row: Participant) =>
        h('span', {
          innerHTML: row.validation ? row.validation.label : 'Non requis'
        })
    },
    {
      content_index: 'etablissement',
      label: 'Etablissement',
      width: 120
    }
  ];

  const columnsParticipants = [
    {
      content_index: 'nomPrenom',
      label: 'Nom',
      width: 308,
      content_custom: (row: Participant) =>
        h(RefonteTableItemParticipantNameAccountStatus, { row })
    },
    {
      content_index: 'statut',
      label: 'Inscription',
      width: 120,
      content_custom: (row: Participant) =>
        h('span', {
          innerHTML: getParticipantInscriptionStatus(row.statut)
        })
    },
    {
      content_index: 'commandeReference',
      label: 'Référence',
      width: 308
    }
  ];

  const columnsFactures = [
    {
      content_index: 'reference',
      label: 'Référence',
      width: 308
    },
    {
      content_index: 'type',
      label: 'Type',
      width: 180
    },
    {
      content_index: 'date',
      label: 'Date',
      width: 120
    },
    {
      content_index: 'montant',
      label: 'Montant',
      width: 120,
      content_custom: (row: any) =>
        h('span', {
          innerHTML: number_utils.methods.formatCurrency(row.montant)
        })
    },
    {
      content_index: 'montantRegle',
      label: 'Payé',
      width: 120,
      content_custom: (row: any) =>
        h('span', {
          innerHTML: number_utils.methods.formatCurrency(row.montantRegle)
        })
    },
    {
      content_index: 'factureNom',
      label: 'Facture',
      width: 140,
      on_click: (row: Facture) => {
        downloadFacture(detail.value?.clientId, row.id);
      },
      content_icon: () => IconDownload,
      class: (row: Facture) => '!flex-grow-0'
    }
  ];

  const signatureManuelleIndiv = ref<boolean>(false);
  const openSignatureManuelleIndiv = () => {
    signatureManuelleIndiv.value = true;
  };

  const signatureManuelle = ref<boolean>(false);
  const openSignatureManuelle = () => {
    signatureManuelle.value = true;
  };

  const signatureManuellePif = ref<boolean>(false);
  const openSignatureManuellePif = () => {
    signatureManuellePif.value = true;
  };
</script>

<style lang="scss" scoped>
  .table-no-space-between {
    :deep(.table-row-content) {
      justify-content: flex-start !important;

      .refonte-table-item {
        flex-grow: 0 !important;
      }
    }
  }
</style>
